module.exports = require('./bundle-url').getBundleURL() + require('./bundle-manifest').resolve("fgrUC");